<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => this.$router.go(-1)"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Planejamento Mensal CAEE
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-title>PLANEJAMENTO MENSAL ATENDIMENTO EDUCACIONAL ESPECIALIZADO</v-card-title>
          <v-card-text>
            <h4>Turma: {{ gestao?.turma ? gestao.turma.descricao : "- - -" }}</h4>
            <h4>Aluno: {{ matricula?.aluno ? matricula.aluno.nomecompleto : "- - -" }}</h4>
            <h4>CETI: {{ gestao?.turma?.franquia ? gestao.turma.franquia.descricao : "- - -" }}</h4>
            <h4>Professor(a): {{ gestao?.profissional ? gestao.profissional.name : "- - -" }}</h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(salvar)" :disabled="submittingForm">
        <!-- Mês e Período -->
        <v-card class="mt-4 mb-4">
          <v-card-text>
            <v-row>
              <v-col cols="12" lg="3">
                <v-select
                  :items="meses"
                  item-text="descricao"
                  item-value="id"
                  v-model="mesSelecionado"
                  return-object
                  label="Selecione o mês"
                  solo
                ></v-select>
              </v-col>

              <!-- Data Início -->
              <v-col cols="12" lg="2">
                <v-menu
                  v-model="menuInicio"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider
                      name="Data Início do Período"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        :value="periodoInicioFormatado"
                        label="Data Início do Período *"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        solo
                        v-bind="attrs"
                        v-on="on"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </template>
                  <v-date-picker
                    v-model="form.periodo_execucao_inicio"
                    locale="pt-BR"
                    @input="menuInicio = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <!-- Data Fim -->
              <v-col cols="12" lg="2">
                <v-menu
                  v-model="menuFim"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider
                      name="Data Fim do Período"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        :value="periodoFimFormatado"
                        label="Data Fim do Período *"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        solo
                        v-bind="attrs"
                        v-on="on"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </template>
                  <v-date-picker
                    v-model="form.periodo_execucao_fim"
                    locale="pt-BR"
                    :min="form.periodo_execucao_inicio"
                    @input="menuFim = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <!-- Exibição do período formatado -->
              <v-col
                cols="12"
                lg="5"
                v-if="periodoInicioFormatado && periodoFimFormatado"
                class="mt-2"
              >
                <v-chip color="primary" outlined>
                  <v-icon left small>mdi-calendar-range</v-icon>
                  Período: {{ periodoInicioFormatado }} a {{ periodoFimFormatado }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Campo de Experiência -->
        <v-card class="mb-4 py-4">
          <v-card-title>Campo de Experiência</v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                v-for="opcao in camposExperienciaOpcoes"
                :key="opcao.valor"
                cols="12"
                sm="6"
                md="4"
                class="py-0"
              >
                <v-checkbox
                  v-model="form.campos_experiencia"
                  :label="opcao.label"
                  :value="opcao.valor"
                  dense
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="py-0">
                <v-checkbox
                  v-model="temOutros"
                  label="Outros"
                  dense
                  hide-details
                  @change="onOutrosChange"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" v-if="temOutros" class="pt-2">
                <ValidationProvider
                  name="Especificação de Outros"
                  :rules="{ required: true, max_chars: 100, no_special_chars: true }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="form.outros_campo_experiencia"
                    label="Especifique Outros *"
                    solo
                    dense
                    :error-messages="errors"
                    counter="100"
                    maxlength="100"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Tabela de Planejamento -->
        <v-card class="mb-4">
          <v-card-title>
            Planejamento
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="adicionarItem" :disabled="submittingForm">
              <v-icon left small>mdi-plus</v-icon>
              Adicionar item
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-2">
            <div
              v-for="(item, index) in form.itens"
              :key="index"
              class="mb-4"
              style="border: 1px solid #e0e0e0; border-radius: 4px; padding: 12px"
            >
              <div class="d-flex justify-space-between align-center mb-2">
                <span class="font-weight-medium">Item {{ index + 1 }}</span>
                <v-btn
                  icon
                  color="error"
                  small
                  @click="removerItem(index)"
                  :disabled="form.itens.length === 1"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </div>
              <v-row>
                <!-- Data -->
                <v-col cols="12" sm="4">
                  <v-menu
                    v-model="item._menuData"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <ValidationProvider
                        :name="`Data (item ${index + 1})`"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          :value="formatarData(item.data)"
                          :label="`Data *`"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          solo
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker v-model="item.data" locale="pt-BR"></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Objeto de Conhecimento -->
                <v-col cols="12">
                  <e-label>Objeto de Conhecimento *</e-label>
                  <ValidationProvider
                    :name="`Objeto de Conhecimento (item ${index + 1})`"
                    :rules="{ required: true, max_chars: 500, no_special_chars: true }"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      v-model="item.objeto_conhecimento"
                      rows="4"
                      solo
                      dense
                      :error-messages="errors"
                      counter="500"
                      maxlength="500"
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>

                <!-- Objetivos -->
                <v-col cols="12">
                  <e-label>Objetivos de Aprendizagem e Desenvolvimento *</e-label>
                  <ValidationProvider
                    :name="`Objetivos de Aprendizagem (item ${index + 1})`"
                    :rules="{ required: true, max_chars: 500, no_special_chars: true }"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      v-model="item.objetivos_aprendizagem"
                      solo
                      dense
                      rows="4"
                      :error-messages="errors"
                      counter="500"
                      maxlength="500"
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>

                <!-- Estratégias -->
                <v-col cols="12">
                  <e-label>Estratégias Didáticas *</e-label>
                  <ValidationProvider
                    :name="`Estratégias Didáticas (item ${index + 1})`"
                    :rules="{ required: true, max_chars: 500, no_special_chars: true }"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      v-model="item.estrategias_didaticas"
                      solo
                      dense
                      rows="4"
                      :error-messages="errors"
                      counter="500"
                      maxlength="500"
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>

                <!-- Recursos -->
                <v-col cols="12">
                  <e-label>Recursos *</e-label>
                  <ValidationProvider
                    :name="`Recursos (item ${index + 1})`"
                    :rules="{ required: true, max_chars: 500, no_special_chars: true }"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      v-model="item.recursos"
                      solo
                      dense
                      rows="4"
                      :error-messages="errors"
                      counter="500"
                      maxlength="500"
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>

        <!-- Botões de ação -->
        <v-col cols="12" class="mt-2">
          <v-row>
            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              class="mr-3"
              lg
              block
            >
              <v-icon left>mdi-content-save</v-icon>
              Salvar
            </v-btn>
          </v-row>
        </v-col>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      submittingForm: false,
      fichaExiste: false,
      gestao: null,
      matricula: null,
      temOutros: false,
      menuInicio: false,
      menuFim: false,
      meses: [
        { id: 1, descricao: "Janeiro" },
        { id: 2, descricao: "Fevereiro" },
        { id: 3, descricao: "Março" },
        { id: 4, descricao: "Abril" },
        { id: 5, descricao: "Maio" },
        { id: 6, descricao: "Junho" },
        { id: 7, descricao: "Julho" },
        { id: 8, descricao: "Agosto" },
        { id: 9, descricao: "Setembro" },
        { id: 10, descricao: "Outubro" },
        { id: 11, descricao: "Novembro" },
        { id: 12, descricao: "Dezembro" },
      ],
      mesSelecionado: { id: new Date().getMonth() + 1 },
      camposExperienciaOpcoes: [
        { valor: "Desenvolvimento Psicomotor", label: "Desenvolvimento Psicomotor" },
        {
          valor: "Desenvolvimento Cognitivo (percepção, atenção, memória)",
          label: "Desenvolvimento Cognitivo (percepção, atenção, memória)",
        },
        { valor: "Linguagem", label: "Linguagem" },
        {
          valor: "Nível de aprendizagem (leitura/escrita e lógica matemática)",
          label: "Nível de aprendizagem (leitura/escrita e lógica matemática)",
        },
        { valor: "Sociabilidade/afetividade", label: "Sociabilidade/afetividade" },
        { valor: "Meio social / família", label: "Meio social / família" },
      ],
      form: {
        periodo_execucao_inicio: "",
        periodo_execucao_fim: "",
        campos_experiencia: [],
        outros_campo_experiencia: "",
        itens: [
          {
            data: "",
            objeto_conhecimento: "",
            objetivos_aprendizagem: "",
            estrategias_didaticas: "",
            recursos: "",
            _menuData: false,
          },
        ],
      },
    };
  },
  computed: {
    periodoInicioFormatado() {
      return this.formatarData(this.form.periodo_execucao_inicio);
    },
    periodoFimFormatado() {
      return this.formatarData(this.form.periodo_execucao_fim);
    },
  },
  mounted() {
    this.loadBasicData();
  },
  watch: {
    mesSelecionado() {
      this.loadBasicData();
    },
  },
  methods: {
    formatarData(dataISO) {
      if (!dataISO) return "";
      const [year, month, day] = dataISO.split("-");
      return `${day}/${month}/${year}`;
    },
    novoItem() {
      return {
        data: "",
        objeto_conhecimento: "",
        objetivos_aprendizagem: "",
        estrategias_didaticas: "",
        recursos: "",
        _menuData: false,
      };
    },
    adicionarItem() {
      this.form.itens.push(this.novoItem());
    },
    removerItem(index) {
      this.form.itens.splice(index, 1);
    },
    onOutrosChange(val) {
      if (!val) {
        this.form.outros_campo_experiencia = "";
        const idx = this.form.campos_experiencia.indexOf("Outros");
        if (idx !== -1) this.form.campos_experiencia.splice(idx, 1);
      } else if (!this.form.campos_experiencia.includes("Outros")) {
        this.form.campos_experiencia.push("Outros");
      }
    },
    async loadBasicData() {
      this.$loaderService.open("Carregando dados...");
      try {
        const { matricula_id, gestaoDeAulasId } = this.$route.params;
        const response =
          await this.$services.educacaoInclusivaService.carregarPlanejamentoMensalAEE(
            matricula_id,
            gestaoDeAulasId,
            this.mesSelecionado.id
          );
        this.matricula = response.matricula;
        this.gestao = response.gestao;
        if (response.ficha) {
          this.fichaExiste = true;
          this.form.periodo_execucao_inicio = response.ficha.periodo_execucao_inicio || "";
          this.form.periodo_execucao_fim = response.ficha.periodo_execucao_fim || "";
          this.form.campos_experiencia = response.ficha.campos_experiencia || [];
          this.form.outros_campo_experiencia = response.ficha.outros_campo_experiencia || "";
          this.form.itens =
            response.ficha.itens && response.ficha.itens.length > 0
              ? response.ficha.itens.map((item) => ({ ...item, _menuData: false }))
              : [this.novoItem()];
          this.temOutros = this.form.campos_experiencia.includes("Outros");
          if (this.$refs.observer) {
            this.$refs.observer.reset();
          }
        } else {
          this.fichaExiste = false;
          this.form.periodo_execucao_inicio = "";
          this.form.periodo_execucao_fim = "";
          this.form.campos_experiencia = [];
          this.form.outros_campo_experiencia = "";
          this.form.itens = [this.novoItem()];
          this.temOutros = false;
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async salvar() {
      this.submittingForm = true;
      try {
        const { matricula_id, gestaoDeAulasId } = this.$route.params;
        // Remove _menuData before sending to API
        const itensLimpos = this.form.itens.map(({ _menuData, ...item }) => item);
        const payload = {
          ...this.form,
          itens: itensLimpos,
          matricula_id,
          gestao_id: gestaoDeAulasId,
          mes_id: this.mesSelecionado.id,
        };
        await this.$services.educacaoInclusivaService.salvarPlanejamentoMensalCAEE(payload);
        this.$toast.success("Planejamento Mensal salvo com sucesso!");
        this.fichaExiste = true;
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
  },
};
</script>

<style scoped></style>
